const news_es = require('./news.json')
export default news_es